import { datadogRum } from '@datadog/browser-rum'

type SessionEventType =
  | 'session:logout:inactivity'
  | 'session:logout:explicit'
  | 'session:logout:cross_tab'
  | 'session:token_refresh:success'
  | 'session:token_refresh:failure'
  | 'session:token_refresh:no_refresh_token'

interface SessionEvent {
  type: SessionEventType
  timestamp: string
  username?: string
  details?: Record<string, unknown>
}

export function useSessionAudit() {
  const logSessionEvent = (type: SessionEventType, details?: Record<string, unknown>) => {
    const userStore = useUserStore()
    const username = userStore.user?.accountOverview?.username ?? 'unknown'

    const event: SessionEvent = {
      type,
      timestamp: new Date().toISOString(),
      username,
      details
    }

    // Emit a Datadog RUM custom action so Support can search and filter
    // session events (by type, username, or session) directly in Datadog.
    // This is a no-op if RUM hasn't been initialized (e.g. during SSR or
    // in tests), so it's safe to call unconditionally.
    try {
      datadogRum.addAction(type, { username, ...details })
    } catch {
      // Ignore — RUM not available in this context
    }

    // Structured console log — useful for local debugging and picked up
    // by any log pipeline that ingests console output. Using console.info
    // with a prefix that's easy to filter.
    console.info('[SessionAudit]', JSON.stringify(event))
  }

  return { logSessionEvent }
}
